import { useEffect, useState } from "react";
import { Box, Button } from "react-bulma-components";
import {
    faCamera,
    faDesktop,
    faFileImage,
    faThumbtack
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../../styles/clientoverlay.module.css";
import ConnectionData from "../../js/connection/ConnectionData";
import ChannelConnection from "../../js/connection/ChannelConnection";
// import UserAlias from "./overlay/UserAlias";
// import HoloLensControls from "./overlay/HoloLensControls";
import FocusButton from "./overlay/FocusButton";
import DrawingOverlay from "./overlay/DrawingOverlay";
import DrawingControls, { DrawingMode } from "./overlay/DrawingControls";

type Props = {
    connection: ChannelConnection;
    connectionData: ConnectionData;
    onScreenshotClick: (connectionData: ConnectionData) => void;
    onUploadClick: (connectionData: ConnectionData) => void;
    //onFocusClick: (connectionData: ConnectionData) => void;
};

export default function ClientOverlay({
    connection,
    connectionData,
    onScreenshotClick,
    onUploadClick,
    //onFocusClick
}: Props) {
    const [isFocused, setFocused] = useState<boolean>(false);
    const [drawingMode, setDrawingMode] = useState<DrawingMode>("none");

    useEffect(() => {
        function onViewFocus(data: ConnectionData | null) {
            if (data?.id === connectionData.id) {
                setDrawingMode("pen");
                setFocused(true);
            } else if (isFocused) {
                setDrawingMode("none");
                setFocused(false);
            }
        }
        connection.events.addListener("onviewfocus", onViewFocus);

        return () => connection.events.removeListener("onviewfocus", onViewFocus);
    }, [connection.events, connectionData.id, isFocused]);
    
    // function focus() {
    //     setFocused(prev => !prev);
    //     onFocusClick(connectionData);
    // }
    
    function isHoloLens() {
        console.log("connectionData.roles", connectionData);
        //return connectionData.roles && connectionData.roles.includes("hololens");
        return connectionData.userAlias && connectionData.userAlias.includes("Unity_Hololens");
    }

    function isScreensharing() {
        return connectionData.roles && connectionData.roles.includes("screenshare");
    }

    // function onUploadClick(): void {
    //     connection.events.notify("onscreenshot", {
    //         connectionData,
    //         videoFrameData: null
    //     });
    // }

    function onFocusClick(focused: boolean) {
        connection.focusView(focused ? connectionData.id : null);
    }

    return (
        <>
            <div style={{ top: 10, left: 10 }} className={styles.client}>
                <Box
                    style={{
                        margin: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "10px 20px 10px 20px",
                        borderRadius: 14
                    }}>
                    {isScreensharing() && <FontAwesomeIcon icon={faDesktop} color="white" style={{ marginRight: 10 }} />}
                    <span style={{ color: "white" }}>{connectionData.userAlias}</span>
                </Box>
                {isHoloLens() && (
                    <>
                        <Button
                            className={styles.button}
                            rounded
                            color="primary"
                            onClick={() => onScreenshotClick(connectionData)}>
                            <FontAwesomeIcon icon={faCamera} />
                        </Button>
                        <Button
                            className={styles.button}
                            rounded
                            color="primary"
                            onClick={() => onUploadClick(connectionData)}>
                            <FontAwesomeIcon icon={faFileImage} />
                        </Button>
                    </>
                )}
            </div>

            <div style={{ position: "absolute", top: 20, right: 20, zIndex: 20 }}>
                <FocusButton isFocused={isFocused} setFocused={onFocusClick} />
            </div>
            {/* <div style={{ top: 10, right: 20, zIndex: 20 }} className={styles.client}>
                <Button
                    style={{
                        backgroundColor: isFocused
                            ? "#3e56c4"
                            : "rgba(0, 0, 0, 0.5)",
                        borderRadius: 14,
                        border: "none"
                    }}
                    onClick={() => setFocused(!isFocused)}>
                    {isFocused && (
                        <span style={{ color: "white", paddingRight: 10 }}>Pinned</span>
                    )}
                    <FontAwesomeIcon icon={faThumbtack} color="white" />
                </Button>
            </div> */}

            <DrawingOverlay
                drawingMode={drawingMode}
                canvasDrawing={connection.sfuConnection.canvasDrawing}
                connectionData={connectionData}
            />

            {isFocused && (
                <div style={{ position: "absolute", left: "50%", bottom: 20, transform: 'translateX(-50%)' }}>
                    <DrawingControls onModeChanged={setDrawingMode} />
                </div>
            )}
        </>
    );
}
